var ytEmebedClass = document.getElementsByClassName("yt-embed-img"),
  ua = navigator.userAgent.toLowerCase(),
  isSafari = false,
  sandboxFlag = '';

if (ytEmebedClass) {
  // Detect browser for allow presentation sandbox flag
  try {
    isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || safari.pushNotification);
  }
  catch(err) {}
  isSafari = (isSafari || ((ua.indexOf('safari') != -1) && (!(ua.indexOf('chrome')!= -1) && (ua.indexOf('version/')!= -1))));
  sandboxFlag = isSafari ? 'allow-scripts allow-same-origin' : 'allow-scripts allow-same-origin allow-presentation';

  function ytEmebedIframeFunc() {
    var ytIframe = this.nextElementSibling;
    ytIframe.classList.add("active");
    
    //show iframe
    lazyLoading.show();

    ytIframe.setAttribute("src", ytIframe.getAttribute("src") + "&autoplay=1");
    if (window.hasOwnProperty("WebEventTracker")) {
      WebEventTracker.logEvent("", "onVideoClicked", {});
    }
    this.parentNode.removeChild(this);
  }

  for (var i = 0; i < ytEmebedClass.length; i++) {
    ytEmebedClass[i].addEventListener('click', ytEmebedIframeFunc, false);
    ytEmebedClass[i].nextElementSibling.setAttribute('sandbox', sandboxFlag);
  }
}
